function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Expander } from '@domain-group/fe-co-expander';
import { ChevronDownIcon, ChevronUpIcon, ExternalLinkIconSmall } from '@domain-group/fe-co-icon';
import { Button, LinkButton } from '@domain-group/fe-co-allhomes-design-system';
import { Section } from '../structure';
import * as styles from './info-box.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var InfoBox = _ref => {
  var logo = _ref.logo,
    type = _ref.type,
    entityName = _ref.entityName,
    description = _ref.description,
    link = _ref.link,
    onDeveloperLinkClick = _ref.onDeveloperLinkClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  return ___EmotionJSX(Section, null, ___EmotionJSX("div", {
    css: styles.header
  }, ___EmotionJSX("div", {
    css: styles.headerDetail
  }, logo && ___EmotionJSX("div", {
    css: styles.logo
  }, ___EmotionJSX("img", {
    css: styles.logoImg,
    src: logo,
    alt: ""
  })), ___EmotionJSX("div", null, ___EmotionJSX("span", {
    css: styles.entityType
  }, "".concat(type.charAt(0).toUpperCase()).concat(type.substring(1)), ":", ' '), ___EmotionJSX("span", null, entityName))), description && ___EmotionJSX(Button, {
    appearance: "ghostNeutral",
    onClick: () => setIsExpanded(!isExpanded)
  }, isExpanded ? ___EmotionJSX(ChevronUpIcon, null) : ___EmotionJSX(ChevronDownIcon, null))), ___EmotionJSX(Expander, {
    expanded: isExpanded,
    isDisabled: !description
  }, description && ___EmotionJSX("div", {
    css: styles.description
  }, description.replace(/<br>/gm, ' ').replace(/<[^>]*>?/gm, '')), link && ___EmotionJSX(LinkButton, {
    css: styles.link,
    appearance: "ghostNeutral",
    href: link,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onDeveloperLinkClick
  }, ___EmotionJSX("span", null, "Know more about ", type, " "), ___EmotionJSX(ExternalLinkIconSmall, null))));
};
InfoBox.propTypes = {
  logo: PropTypes.string,
  type: PropTypes.oneOf(['developer', 'builder', 'sales team']).isRequired,
  entityName: PropTypes.string.isRequired,
  description: PropTypes.string,
  link: PropTypes.string,
  onDeveloperLinkClick: PropTypes.func
};
InfoBox.defaultProps = {
  logo: null,
  description: null,
  link: null,
  onDeveloperLinkClick: () => {}
};